export default{
    InvoiceMent:{
        Headers:{
            title:"Orders with payment terms will be invoiced collectively upon settlement. This page does not include payment term orders.",
            title1:"Invoiceable Amount",
            invoTitle:"Invoice Title",
            title2:"Invoice Records",
        },
        form:{
            query:"Order Number",
            invoApplyStatus:"Invoice Status",
            datepicker:"Application Date",
        },
        placeholder:{
            query:"Enter order number",
            invoApplyStatus:"All",
            datepicker:["Start date","End date"],
        },
        Message:{
               zqjsd:"Payment term settlement overdue",
               zqjsd1:"days, a late fee of",
               zqjsd2:"% will be charged on the settlement amount",
        },
        Alert:{
        },
        Button:{
            goInvo:'Create Invoice',
            btnInvoTile:"Manage Invoice Titles",
            btnSeach:"Search",
            btnReset:"Reset",
            btnDetail:"View Details",
            btnConfirm:"Confirm"
        },
        Placeholder:{
        },
        Validate:{
        },
        tooltip:{
            content:"Invoiceable Amount = Total consumable amount - Previously invoiced amount"
        },
        Description:{
            noData:'No invoices available',
            emptyText:"No data"
        },
        Table:{
            headerName:['Application Date','Invoice Type','Recipient Entity','Invoice Title','Issuing Entity','Order Number','Invoice Amount','Status','Action'],
        }
    }
}